import { useEffect } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { toast } from "sonner";

/**
 * Shows a persistent toast when a new service worker (new app version) is
 * waiting. Clicking "Reload" activates it (skipWaiting) and reloads the page.
 * Paired with `registerType: 'prompt'` in vite.config.ts.
 */
export function PWAUpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  useEffect(() => {
    if (!needRefresh) return;
    toast("A new version is available", {
      id: "pwa-update",
      duration: Infinity,
      action: {
        label: "Reload",
        onClick: () => updateServiceWorker(true),
      },
    });
  }, [needRefresh, updateServiceWorker]);

  return null;
}
